const { DateTime } = require('luxon')
const { nanoid, customAlphabet } = require('nanoid')
const { uppercase } = require('nanoid-dictionary')
const { curry, pipe, chain, assoc, prop, dissoc } = require('ramda')

const shortid = () => nanoid(9)

const uppercaseShortId = (length = 5) => customAlphabet(uppercase, length)()

function metersToMiles(distanceInMeters) {
  const conversionFactor = 0.6214
  return (distanceInMeters / 1000) * conversionFactor
}

const toDateTime = (d, tz, tzOptions = {}) => {
  return (d instanceof DateTime ? d : typeof d === 'string' ? DateTime.fromISO(d) : DateTime.fromJSDate(d)).setZone(tz, tzOptions)
}

const parseTime = (time, tz, format = 'h:mma') => {
  try {
    time = DateTime.fromFormat(time, format, { zone: 'utc' })
    return tz ? time.setZone(tz, { keepLocalTime: true }) : time
  } catch {
    return null
  }
}

const fromLocalHours = (hours, tz) => {
  return parseTime(hours, tz)?.startOf('minute')
}

const renameProp = curry((from, to) => pipe(chain(assoc(to), prop(from)), dissoc(from)))

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

const calculateMonthTargetWithOverrides = (labels, overrides = {}) => {
  if (!labels.length) {
    return { count: 0, percent: 0 }
  }
  const percent = labels.reduce((acc, l) => {
    const override = overrides[l._id]
    const monthTargetPercent = override?.monthTargetPercent ?? (l.monthTargetPercent || 0)
    return acc + monthTargetPercent
  }, 0)

  return { count: labels.length, percent }
}

const utils = { shortid, uppercaseShortId, metersToMiles, toDateTime, parseTime, fromLocalHours, renameProp, calculateMonthTargetWithOverrides, sleep }

module.exports = utils
